import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { commonActions } from "stores/common/commonActions";
import { jarvisPrimeOnboardingActions } from "stores/jarvisPrime/jarvisPrimeOnboarding/jarvisPrimeOnboardingActions";

const mapStateToProps = (state) => {
  return {
    currentStagePrime: state.jarvisPrime.primeOnboarding.currentStagePrime,
    riskProfiles: state.common.riskProfiles,
    riskAssessmentQuestions: state.common.riskAssessmentQuestions,
    loginProfile: state.customer.loginProfile,
    isRiskProfileLoading: state.common.loading.riskProfiles,
    isRiskAssessmentLoading: state.common.loading.riskAssessmentQuestions,
    suggestedRiskId: state.jarvisPrime.primeOnboarding.suggestedRiskId,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      updatePrimeOnboardingDataAction:
        jarvisPrimeOnboardingActions.updatePrimeOnboardingData,
      getRiskAssessmentQuestionsAction:
        commonActions.getRiskAssessmentQuestions,
      getRiskProfilesAction: commonActions.getRiskProfiles,
      getOnboardingDataAction:
        jarvisPrimeOnboardingActions.getOnboardingData,
    },
    dispatch
  );

const PrimeRiskAssessmentStore = (Container) =>
  connect(mapStateToProps, mapDispatchToProps)(Container);
export default PrimeRiskAssessmentStore;
